import { render, staticRenderFns } from "./MoreTyme.vue?vue&type=template&id=166b24aa&scoped=true"
import script from "./MoreTyme.vue?vue&type=script&lang=js"
export * from "./MoreTyme.vue?vue&type=script&lang=js"
import style0 from "./MoreTyme.vue?vue&type=style&index=0&id=166b24aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "166b24aa",
  null
  
)

export default component.exports